import React, { useState } from "react";
import styled from "styled-components";
import { Link, useHistory } from "react-router-dom";
import logo from "../assets/birthed_logo.png";
import { v4 as uuid } from "uuid";
import firebase from "firebase";

const UserContext = React.createContext(null);

export function UserProvider({ children }) {
  const userState = React.useState(
    JSON.parse(window.localStorage.getItem("birth-ed-mn"))
  );

  console.log({ userState });

  return (
    <UserContext.Provider value={userState}>{children}</UserContext.Provider>
  );
}

function useUsername() {
  const user = React.useContext(UserContext)?.[0];
  return user?.name;
}

export function useUserId() {
  const user = React.useContext(UserContext)?.[0];
  console.log(user);
  return user?.id;
}

function useSetUser() {
  const [user, setUser] = React.useContext(UserContext);

  console.log({ user });

  return function(username) {
    let { id, name } = user ?? {};
    if (!id) {
      id = uuid();
    }
    name = username;
    window.localStorage.setItem("birth-ed-mn", JSON.stringify({ id, name }));
    firebase
      .database()
      .ref(`people/${id}`)
      .set({ name });
    setUser({ id, name });
  };
}

const ClassHeader = styled.nav`
  z-index: 1000;
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: var(--blue);
  padding: 0.5rem;
`;

export const ClassroomContainer = styled.div`
  min-height: 100vh;
`;

const HomeLink = styled(Link)`
  display: block;
`;

const HomeLinkImage = styled.img`
  max-height: 2rem;
`;

export const ClassroomBody = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem;
`;

const ClassroomInput = styled.input`
  padding: 0.5rem;
  outline: none;
  border: 1px solid var(--blue);
`;

const FormCard = styled.div`
  border: 1px solid var(--blue);
  padding: 2rem;
  display: flex;
  max-width: 40vw;
  min-width: 30vw;
  flex-direction: column;
  *:not(:last-child) {
    margin-bottom: 1rem;
  }
`;

const FormTitle = styled.h1`
  font-size: 2rem;
  color: var(--blue);
  font-family: var(--title);
`;

export const FormButton = styled.button`
  outline: 0;
  display: block;
  color: var(--white);
  background-color: var(--blue);
  font-size: 1rem;
  border-radius: 0.5rem;
  text-decoration: none;
  padding: 0.5rem;
  text-align: center;
  font-family: var(--body);
`;

const CenteredSection = styled.section`
  width: 100vw;
  text-align: center;
  padding: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

function CaptureUsername() {
  const [userInput, setUserInput] = useState("");

  const setUserName = useSetUser();

  const buttonEnabled = userInput.length !== 0;

  function doSetUserName() {
    if (buttonEnabled) {
      setUserName(userInput);
    }
  }

  return (
    <CenteredSection>
      <FormCard>
        <FormTitle>Tell us you name</FormTitle>
        <ClassroomInput
          onChange={e => {
            setUserInput(e.target.value);
          }}
          placeholder="username"
        />
        <FormButton onClick={doSetUserName} disabled={!buttonEnabled}>
          Proceed to class
        </FormButton>
      </FormCard>
    </CenteredSection>
  );
}

const Grid = styled.div`
  width: 80vw;
  display: grid;
  grid-gap: 1rem;
  grid-template-columns: repeat(3, 1fr);
  padding: 3rem;
  justify-items: center;
`;

const Card = styled.div`
  height: 10rem;
  width: 10rem;
  background-color: var(--gold);
  color: var(--blue);
  padding: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const CardTitle = styled.h3`
  font-size: 1.5rem;
  color: var(--blue);
  font-family: var(--body);
  font-weight: bold;
`;

function ClassroomMenu() {
  const userName = useUsername();
  const history = useHistory();
  return (
    <CenteredSection>
      <FormTitle> Welcome, {userName}</FormTitle>
      <Grid>
        <Card onClick={() => history.push("/cardflip")}>
          <CardTitle>Card Flip</CardTitle>
        </Card>
        <Card onClick={() => history.push("/timeline")}>
          <CardTitle>Timeline</CardTitle>
        </Card>
        <Card onClick={() => history.push("/valuespectrum")}>
          <CardTitle>Value Spectrum</CardTitle>
        </Card>
      </Grid>
    </CenteredSection>
  );
}

export function ClassroomNav({ backToClassroom, children }) {
  const history = useHistory();
  return (
    <ClassHeader>
      <HomeLink to="/">
        <HomeLinkImage src={logo} />
      </HomeLink>
      {children && children}
      {backToClassroom ? (
        <FormButton
          onClick={() => {
            history.push("/classroom");
          }}
        >
          Back to classroom
        </FormButton>
      ) : null}
    </ClassHeader>
  );
}

export function Classroom() {
  const nameGiven = Boolean(useUsername());
  return (
    <ClassroomContainer>
      <ClassroomNav />
      <ClassroomBody>
        {!nameGiven ? <CaptureUsername /> : <ClassroomMenu />}
      </ClassroomBody>
    </ClassroomContainer>
  );
}
